import { GET_POLICY } from '../../constants/actions/policy';

export function getPolicy() {
    return {
        type: GET_POLICY,
    };
}
